import React from 'react';

import Icon from '/component/base/Icon';
import {ACCEPTDECLINE} from '/enum/candidates.enum';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './CandidateReportAcceptByIconComponent.style';

export type PersonDetails = {
  createdTs: string;
  source: string;
  acceptBefore: string;
  status: string;
};
interface CandidateReportAcceptByIconComponentProps {
  item: PersonDetails;
  reportName: string;
}

export const CandidateReportAcceptByIconComponent = ({
  item,
  reportName,
}: CandidateReportAcceptByIconComponentProps) => {
  const showDay = getDateUtilDefaultInstance().checkDate(
    item?.acceptBefore,
    reportName,
  );
  return (
    <>
      {item?.acceptBefore && item?.status === ACCEPTDECLINE && showDay && (
        <Icon name="alert" style={styles.alertIcon} />
      )}
    </>
  );
};
